import { SysConfigBaseApi } from "./SysConfigBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * 项目工程划分类别数据操作
 */
export class UserinforsignkeyApi extends SysConfigBaseApi {
  public get ControllerName(): any {
    return 'Userinforsignkey'
  }
 
}